// Components
import { FloatPanel } from "../../../../../components/floatPanel";
import { EditorSections } from "../../../../../components/editorSections";
import { Details } from "./details";

// API
import { getCustomer } from "../../../../../api/clients";
import { History } from "./history";
import { PanelContent } from "../../../../../components/floatPanelContent";

export const Edition = () => {
  const tabsContent = [
    {
      content: (
        <>
          <EditorSections
            sections={[
              {
                id: "contact",
                title: "Ficha del cliente",
                description:
                  "Datos de contacto y direcciones guardadas por el cliente.",
                content: <Details />,
              },
              {
                id: "history",
                title: "Historial de pedidos",
                description: "Actividad del cliente en este negocio.",
                content: <History />,
              },
            ]}
          />
        </>
      ),
    },
  ];

  return (
    <FloatPanel
      template={
        <PanelContent
          entityLabel="cliente"
          getQuery={getCustomer}
          tabsContent={tabsContent}
          /*handleActive={handleActive}*/
          /*horizontalNavigation={horizontalNavigation}*/
        />
      }
    />
  );
};
